//const BASE_URL = 'http://15.160.171.254/api/1/';
//const LOGIN = 'http://15.160.171.254/login';
const BASE_URL = 'https://affiliati.lastoa.com/api/1/';
const LOGIN = 'https://affiliati.lastoa.com/login';
const REFRESH_ENDPOINT = 'auth/refresh';
const ACCESS_TOKEN_KEY = 'affiliato_access_token';
const REFRESH_TOKEN_KEY = 'affiliato_refresh_token';

async function storeTokens(accessToken, refreshToken) {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
}

function isLogged() {
  if(localStorage.getItem(ACCESS_TOKEN_KEY) !== null){
    return true;
  } else {
    return false;
  }
}

function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

function setAccessToken(token) {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
}

function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

function setRefreshToken(token) {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
}

function clearTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}

async function callServerNoAuth(endpoint, payload = {}, method = 'POST') {
  try {
    
    if(isLogged()){
      return await callServer(endpoint, payload);
    }

    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method,
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': window.API_KEY
      },
      body: method === 'POST' ? JSON.stringify(payload) : null,
    });


    // DEBUG: log testo per endpoint specifici
    if (endpoint === '/asa') {
    }

    const result = await tryParseJSON(response);
    if (!response.ok) {
      throw new Error(result?.error || 'Errore generico dal server (noAuth)');
    }
    return result;
  } catch (err) {
    throw err;
  }
}


/**
 * Chiamata generica al server con token (e refresh automatico)
 */
async function callServer(endpoint, payload = {}, method = 'POST') {
  try {
    // 1. Recupera access token
    let accessToken = getAccessToken();
    if (!accessToken) {
      throw new Error('Access Token mancante. Esegui il login.');
    }

    // 2. Esegui richiesta
    let response = await fetch(`${BASE_URL}${endpoint}`, {
      method,
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        'x-api-key': window.API_KEY
      },
      body: method === 'POST' ? JSON.stringify(payload) : null,
    });

    // DEBUG: log testo clone per ogni chiamata
    if (endpoint === '/aaasa') {
    }

    // 3. Gestione 401
    if (response.status === 401) {
      const errorData = await tryParseJSON(response);
      if (errorData?.code === 'TOKEN_EXPIRED') {
        const success = await refreshAccessToken();
        if (!success) {
          logout_function();
          throw new Error('Impossibile rinnovare il token. Esegui il login.');
        }
        // Ripeti richiesta con nuovo token
        accessToken = getAccessToken();
        response = await fetch(`${BASE_URL}${endpoint}`, {
          method,
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
            'x-api-key': window.API_KEY
          },
          body: method === 'POST' ? JSON.stringify(payload) : null,
        });
        if (response.status === 401) {
          logout_function();
          throw new Error('Token ancora non valido dopo il refresh. Esegui il login.');
        }
      } else if (errorData?.code === 'TOKEN_INVALID' || errorData?.code === 'TOKEN_REVOKED') {
        logout_function();
        throw new Error(`Access token non valido (${errorData.code}). Esegui nuovamente il login.`);
      } else {
        logout_function();
        throw new Error(`Chiamata non autorizzata. Code: ${errorData?.code || 'unknown'}`);
      }
    }

    // 4. Parse finale
    const result = await tryParseJSON(response);
    if (!response.ok) {
      throw new Error(result?.error || 'Errore generico dal server');
    }
    return result;

  } catch (err) {
    throw err;
  }
}

/**
 * Helper per parse-are la risposta JSON (gestisce eventuali errori).
 */
async function tryParseJSON(response) {
  try {
    return await response.json();
  } catch {
    return null; // Se non è JSON valido
  }
}


let refreshInFlight = null;

async function refreshAccessToken() {
  if (refreshInFlight) {
    return refreshInFlight;
  }

  refreshInFlight = (async () => {
    try {
      const refreshToken = getRefreshToken();
      if (!refreshToken) return false;

      const res = await fetch(`${BASE_URL}${REFRESH_ENDPOINT}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': window.API_KEY
        },
        body: JSON.stringify({ refresh_token: refreshToken }),
      });

      const data = await res.json();

      if (res.ok && data.success) {
        setAccessToken(data.access_token);
        if (data.refresh_token) {
          setRefreshToken(data.refresh_token);
        }
        return true;
      }
      return false;
    } finally {
      refreshInFlight = null;
    }
  })();

  return refreshInFlight;
}

async function logout_function() {
  await clearTokens();
  window.location.href = LOGIN;
}
